/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Title_FieldInputs */

const cs_contracts_title_field = /** @type {(inputs: Contracts_Title_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const en_contracts_title_field = /** @type {(inputs: Contracts_Title_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Contracts_Title_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_title_field = /** @type {((inputs?: Contracts_Title_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Title_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_title_field(inputs)
	return cs_contracts_title_field(inputs)
});